import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, "Tên kho phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập tên kho"),
  isActive: yup.boolean(),
});
